module.exports = __webpack_public_path__ + "img/active2.1d231d0f.png";